import React, { Component } from "react";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
//moment import
import moment from "moment-timezone";
//Service import
import service from "../../../services";

//Loader import
import Loader from "../../loader";

//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import EditIcon from "../../../icons/EditIcon";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};
let sub;
let statusFilterList = [];

class EmailListComp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      emailTemplateListDocs: [],
      data: [
        {
          label: "product list",
          Content: "This is content for Tab 1",
        },
      ],
    };
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    this.getAllProductCouponList();
    this.getAllProductCouponEvent();
    this.setState({
      loaderFlag: true,
    });
  };
  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getAllProductCouponEvent = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "email|getAllMailTemplate":
          this.setState(
            {
              emailTemplateListDocs: response.data.sort((a, b) => a.emailTitle.localeCompare(b.emailTitle)),
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
            }
          );
          break;
      }
    });
  };

  getAllProductCouponList = () => {
    this.apiserve.sendevent("email|getAllMailTemplate", {});
  };
  editTalkEventListData = (item) => {
    this.props.EmailEditList(item);
    this.props.history.push({ pathname: "/email-detail" });
  };


  render() {
    const { emailTemplateListDocs } = this.state;
    return (
      <>
        <table>
          <thead>
          <tr>
            <th>Template Title</th>
            <th>Template identifier</th>
            <th>Email Title</th>
            <th>Action</th>
            
          </tr>
          </thead>
           <tbody>
              {emailTemplateListDocs &&
                emailTemplateListDocs.map((item, i) => (
                  <>
                  <tr
                  
                    className={item.status === 2 ? "disable" : ""}
                  >
                    <td>
                      <strong>{!!item.emailTitle ? item.emailTitle : "-"}</strong>
                    </td>
                    <td>
                      <strong>{item.identifier}</strong>
                    </td>
                    <td>
                      <strong>{item.title}</strong>
                    </td>
                    <td>
                      <span className="pointer"  onClick={() => this.editTalkEventListData(item._id)}><EditIcon /></span>
                    </td>
                  </tr>
                  {/* <tr>
                      <td><strong>All-Access Pass</strong></td>
                      <td><p>Invitation Only</p></td>
                      <td><p>$2500</p></td>
                      <td><p>10/09/2020</p></td>
                      <td><p>10/09/2020</p></td>
                      <td><p>Live</p></td>
                  </tr>
                  <tr className="disable">
                      <td><strong>All-Access Pass</strong></td>
                      <td><p>Invitation Only</p></td>
                      <td><p>$2500</p></td>
                      <td><p>10/09/2020</p></td>
                      <td><p>10/09/2020</p></td>
                      <td><p>Disable</p></td>
                  </tr>
                  <tr>
                      <td><strong>All-Access Pass</strong></td>
                      <td><p>Invitation Only</p></td>
                      <td><p>$2500</p></td>
                      <td><p>10/09/2020</p></td>
                      <td><p>10/09/2020</p></td>
                      <td><p>Live</p></td>
                  </tr>
                  <tr>
                  <td><strong>All-Access Pass</strong></td>
                  <td><p>Invitation Only</p></td>
                  <td><p>$2500</p></td>
                  <td><p>10/09/2020</p></td>
                  <td><p>10/09/2020</p></td>
                  <td><p>Live</p></td>
              </tr> */}
                </>
              ))}
            </tbody>
        </table>
        {/* Loader */}
        {this.state.loaderFlag ? <Loader /> : ""}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailListComp);
